import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Budget } from '../store/reselectors/budget.data';
import { BudgetService } from './budget.service';
import { JoiResource } from 'globals/store/resources.data';
import { ResourceService } from './resources.service';
import { ShareService } from './share.service';
import { Dictionary } from '@ngrx/entity';

// separating this out into its own service for better separation of concerns / clarity between services
@Injectable({ providedIn: 'root' })
export class QuotesService {
  readonly api = `${environment.functionsURL}api/app`;
  constructor(
    public http: HttpClient,
    public store: Store,
    private budgetService: BudgetService,
    private resourceService: ResourceService,
    private shareService: ShareService
  ) {}
  
  async deleteQuotesFromBudget(budget: Budget, quoteIds: string[], resources: Dictionary<JoiResource>) {
    const resourcesToUpdate:JoiResource[] = []
    quoteIds.filter(id => budget.quotes[id]).forEach(quoteId => {
      const quote = budget.quotes[quoteId]
      delete budget.quotes[quoteId]
      this.shareService.deleteQuoteInfo(quoteId)
      const resource = resources[quote.resourceId]
      console.log({ resource, quoteId, resources })
      if (!resource) return
      resource.quoteIds = resource.quoteIds.filter(id => id !== quoteId)
      if (!resourcesToUpdate.find(r => r.id === quote.resourceId)) resourcesToUpdate.push(resource) // this is okay, pushing a reference that could be mutated several times
    })
    await this.budgetService.updateBudget(budget.eventId, budget)
    await this.resourceService.updateResources(resourcesToUpdate)
  }
}